import api from 'ApiConfig';

const companyServices = {
  createCompany: async (data) => {
    return api.post('/company/create', data);
  },
  getAllCompanies: async () => {
    return api.get('/company/all');
  },
  getCompaniesWithClients: async () => {
    return api.get('/company/with-clients');
  },
  getCompanyById: async (id) => {
    return api.get(`/company/${id}`);
  },
  updateCompany: async (id, data) => {
    return api.put(`/company/${id}`, data);
  },
  toggleCompanyStatus: async (id, data) => {
    return api.patch(`/company/${id}/toggle-status`, data);
  },
  deleteCompany: async (id) => {
    return api.delete(`/company/${id}`);
  },
};

export default companyServices;
